import { START_XERO_CONNECT_URL } from './functionURLs';

export async function connectXero({ user, teamId }) {
  if (!user) throw new Error('Sign in to reconnect Xero.');
  const token = await user.getIdToken();
  const response = await fetch(START_XERO_CONNECT_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ teamId }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.error || 'Unable to connect Xero.');
  if (!data?.url) throw new Error('Xero connect URL not available.');
  window.location.href = data.url;
}
